var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHorizontalResolution = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#clip0_9628_12010)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 12h10M5 9v6M19 9v6"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 0.5,
  stroke: "currentColor",
  rx: 3.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9628_12010"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#fff",
  rx: 4
})))));
export default SvgHorizontalResolution;